import { FC, memo } from 'react';
import styled from 'styled-components';

import { DefaultText } from '@components/text/Text';
import { DefaultTitle } from '@components/text/Title';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 24px;
`;

const Inbox: FC = () => {
  return (
    <Container>
      <DefaultTitle>Inbox</DefaultTitle>

      <DefaultText>Coming soon</DefaultText>
    </Container>
  );
};

export default memo(Inbox);
